import React, { useRef, useState, useEffect, useContext } from "react";
import {
  Upload,
  Button,
  Input,
  Card,
  Flex,
  Row,
  Col,
  Breadcrumb,
  Form,
  notification,
  Popconfirm,
  Checkbox,
  List,
  Popover,
  theme,
} from "antd";
import {
  PlusOutlined,
  LoadingOutlined,
  HomeOutlined,
  CloseCircleOutlined,
  CheckCircleOutlined,
  LockOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { decodeToken } from "react-jwt";
import UserAPI from "../../restAPI/UserAPI";
import validationRules from "../../assets/validation/rules";
import validateForm from "../../utils/FormValidation";
import SettingAPI from "../../restAPI/SettingAPI";
import { RefreshContext } from "../../RefreshContext";
import { logout } from "../../redux/slices/authSlice";

const ProfilePage = () => {
  const { token } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [fileList, setFileList] = useState([
    {
      uid: "-1",
      name: "image.png",
      status: "done",
      url: null,
    },
  ]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState();
  const [payload, setPayload] = useState({
    _id: "",
    firstName: "",
    lastName: "",
    email: "",
    roleId: "",
    userType: "",
    groupId: localStorage.getItem("groupId"),
    companyId: localStorage.getItem("companyId"),
    status: 1,
    profilePicture: "",
  });
  const [errors, setErrors] = useState({});
  const [isModified, setIsModified] = useState(false);
  const [isPasswordValidated, setIsPasswordValidated] = useState(false);
  const { refreshLayout } = useContext(RefreshContext);
  const [api,contextHolder] = notification.useNotification();
  const [showPasswordFields, setShowPasswordFields] = useState(false);
  const [passwordData, setPasswordData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const [loadingData, setLoadingData] = useState({
    firstName: "",
    lastName: "",
  });
  const [showPopconfirm, setShowPopconfirm] = useState(false);
  const [cancelButtonDisabled, setCancelButtonDisabled] = useState(false);
  const [popoverVisible, setPopoverVisible] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const notificationShown = useRef(false);
  const isUpdated = useRef(false);
  const currentPasswordRef = useRef(null);
  const newPasswordRef = useRef(null);
  const confirmNewPasswordRef = useRef(null);

  const clearPasswordData = () => {
    currentPasswordRef.current.value = "";
    newPasswordRef.current.value = "";
    confirmNewPasswordRef.current.value = "";
  };
  const openNotificationWithIcon = (type, message, description, placement) => {
   // if (!notificationShown.current) {
      notification[type]({
        message: message,
        description: description,
        placement,
      });
      notificationShown.current = true;
      setTimeout(() => {
        notificationShown.current = false;
      }, 5000);
   // }
  };

  const goHome = () => {
    navigate("../dashboard");
  };

  useEffect(() => {
    //decode token
    if (token != null) {
      const decodedTokenValue = decodeToken(token);
      console.log(token);
      getUserById(decodedTokenValue.userId);
    }
  }, [token]);

  const getUserById = async (id) => {
    await UserAPI.getUserById(
      token,
      localStorage.getItem("groupId"),
      localStorage.getItem("companyId"),
      id
    )
      .then((res) => {
        if (res?.data) {
          console.log("profile API Data :",JSON.stringify(res.data));
          let status = 1;
          if (res.data.status) {
            status = 1;
          } else {
            status = 0;
          }
          setLoadingData({
            _id: res.data._id,
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            email: res.data.email,
            roleId: res.data.role.id,
            userType: res.data.role.name,
            groupId: res.data.groupId,
            companyId: res.data.companyId,
            status: status,
            profilePicture: res.data.profilePicture || null,
          });
          setPayload({
            _id: res.data._id,
            firstName: res.data.firstName,
            lastName: res.data.lastName,
            email: res.data.email,
            roleId: res.data.role.id,
            userType: res.data.role.name,
            groupId: res.data.groupId,
            companyId: res.data.companyId,
            status: status,
            profilePicture: res.data.profilePicture || null,
          });

          if (res.data.profilePicture) {
            setFileList([{ url: res.data.profilePicture }]);
          } else {
            setFileList([]); // Empty fileList when no profile picture
          }

          setIsLoad(true);
        }
      })
      .catch((err) => {
        console.log("error getting user data :", err.message);
      });
  };

  const beforeUpload = async (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isJpgOrPng) {
      //message.error("You can only upload JPG/PNG files");
      openNotificationWithIcon(
        "error",
        "profile picture update error",
        `You can only upload JPG/PNG files`,
        "bottomLeft"
      );
      return false;
    }

    if (!isLt2M) {
     // message.error("Image must be smaller than 2MB");
      openNotificationWithIcon(
        "error",
        "profile picture update error",
        `Image must be smaller than 2MB`,
        "bottomLeft"
      );
      return false;
    }
    setFile(file);
    isUpdated.current = true;
    setPayload({
      ...payload,
      profilePicture: file,
    });
    if(isJpgOrPng && isLt2M)
      {

        if(loadingData.profilePicture === null || loadingData.profilePicture !== payload.profilePicture)
        {
          await uploadProfilePicture(file);
        }
      }
    //return isJpgOrPng && isLt2M;
    return false;
  };



  const handleChange = ({ fileList: newFileList }) => {
    const isValidFile = newFileList.every(
      (file) =>
        (file.type === "image/jpeg" || file.type === "image/png") &&
        file.size / 1024 / 1024 < 2
    );

    if (!isValidFile) {
      return false;
    }

    setFileList(newFileList);

    const isFileListChanged =
      newFileList.length > 0
        ? newFileList[0].url !== loadingData.profilePicture
        : loadingData.profilePicture !== null;

    setLoading(false);
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => {
        file.preview = reader.result;
        setPreviewImage(reader.result);
      };
    } else {
      setPreviewImage(file.url || file.preview);
    }
    setPreviewOpen(true);
  };

  const handleRemove = async(file) => {
    await deleteMyProfilePicture();
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const validateFormData = (data) => {
    const validationResult = validateForm(data, validationRules);
    if (!validationResult.isValid) {
      const err = validationResult.errors;
      const newErrors = {};
      Object.keys(err).forEach((value) => {
        setIsModified(false);

        newErrors[value] = err[value];
      });
      setErrors((prev) => ({ ...prev, ...newErrors }));
    } else {

      if(showPasswordFields && !isPasswordValidated)
      {
      console.log(isPasswordValidated)
        setIsModified(false);
      }
      else{
        setIsModified(true);
      }
      
      const keyData = Object.keys(data)[0];
      console.log("validation keydata",keyData)
      setErrors((prev) => ({ ...prev, [keyData]: "" }));
    }
  };

  const passwordRules = [
    { id: 1, text: "At least 8 characters", pattern: /.{8,}/ },
    { id: 2, text: "At most 15 characters", pattern: /^.{0,15}$/ },
    { id: 3, text: "At least one uppercase letter", pattern: /[A-Z]/ },
    { id: 4, text: "At least one lowercase letter", pattern: /[a-z]/ },
    { id: 5, text: "At least one number", pattern: /\d/ },
    { id: 6, text: "At least one special character", pattern: /[@$!%*?&]/ },
  ];

  const {
    token: { colorTextQuaternary },
  } = theme.useToken();

  const checkRule = (pattern) => pattern.test(passwordData.newPassword);

  const renderPasswordRules = () => (
    <List
      size="small"
      dataSource={passwordRules}
      renderItem={(rule) => (
        <List.Item>
          <span style={{ color: checkRule(rule.pattern) ? "green" : "red" }}>
            {checkRule(rule.pattern) ? (
              <CheckCircleOutlined />
            ) : (
              <CloseCircleOutlined />
            )}{" "}
            {rule.text}
          </span>
        </List.Item>
      )}
    />
  );

  const validatePasswords = (passwordData) => {
    const errors = {};
    let isValid = true;

    const rules = {
      newPassword: (value, inputs) => {
        if (!value) {
          isValid = false;
          return "New Password is required";
        } else if (value.length < 8) {
          isValid = false;
          return "Password does not meet the requirements.";
        } else if (value.length > 15) {
          isValid = false;
          return "Password does not meet the requirements.";
        } else if (!/[A-Z]/.test(value)) {
          isValid = false;
          return "Password does not meet the requirements.";
        } else if (!/[a-z]/.test(value)) {
          isValid = false;
          return "Password does not meet the requirements.";
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
          isValid = false;
          return "Password does not meet the requirements.";
        } else if (!/[0-9]/.test(value)) {
          isValid = false;
          return "Password does not meet the requirements.";
        } else if (value === inputs.currentPassword) {
          isValid = false;
          return "Current password and New password should not be the same";
        }
        return null;
      },

      confirmNewPassword: (value, inputs) => {
        if (!value) {
          isValid = false;
          return "Confirm Password is required";
        } else if (value !== inputs.newPassword) {
          isValid = false;
          return "Passwords do not match";
        }
        return null;
      },
      currentPassword: (value, inputs) => {
        if (!value) {
          isValid = false;
          return "Current Password is required";
        } else if (value.length < 8) {
          isValid = false;
          return "Current Password must be at least 8 characters";
        } else if (value.length > 15) {
          isValid = false;
          return "Current Password must not exceed 15 characters";
        } else if (!/[A-Z]/.test(value)) {
          isValid = false;
          return "Current Password must be at least 1 uppercase character";
        } else if (!/[a-z]/.test(value)) {
          isValid = false;
          return "Current Password must be at least 1 lowercase character";
        } else if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) {
          isValid = false;
          return "Current Password must be at least 1 special character";
        } else if (!/[0-9]/.test(value)) {
          isValid = false;
          return "Current Password must be at least 1 numeric character";
        }
        return null;
      },
    };

    // Validate each field
    Object.keys(passwordData).forEach((key) => {
      if (rules[key]) {
        const error = rules[key](passwordData[key], passwordData);
        if (error) {
          errors[key] = error;
        }
      }
    });

    setIsModified(isValid && Object.keys(errors).length === 0);
    setIsPasswordValidated(isValid && Object.keys(errors).length === 0)

    return {
      isValid: isValid && Object.keys(errors).length === 0,
      errors,
    };
  };

  const handleCancel = () => {
    setCancelButtonDisabled(true);
    openNotificationWithIcon(
      "error",
      "Abort",
      `Update cancelled`,
      "bottomLeft"
    );

    setTimeout(() => {
      setShowPopconfirm(false);
      setCancelButtonDisabled(false);
    }, 3000);
  };

  const handleCreateUpdateClick = (e) => {
    e.preventDefault();
    setShowPopconfirm(true);
  };

  const onSubmitChange = async () => {
    setShowPopconfirm(false);

    const requestData = {
      firstName: payload.firstName,
      lastName: payload.lastName,
      email: payload.email,
      roleId: payload.roleId,
      groupId: payload.groupId,
      companyId: payload.companyId,
      status: payload.status,
    };
    if (JSON.stringify(loadingData) !== JSON.stringify(payload)) {

      await UserAPI.updateMe(
        token,
        localStorage.getItem("groupId"),
        localStorage.getItem("companyId"),
        requestData
      )
        .then((response) => {
          openNotificationWithIcon(
            "success",
            "Successful",
            `${response.message}`,
            "bottomLeft"
          );

          setIsModified(false);
        })
        .catch((err) => {
          if (err.response) {
            openNotificationWithIcon(
              "error",
              "Profile update failed",
              `${err.response.data.message}`,
              "bottomLeft"
            );
            setIsModified(true);
          } else {
            openNotificationWithIcon(
              "error",
              "Profile update failed",
              `${err.message}`,
              "bottomLeft"
            );
            setIsModified(true);
          }
        });
    }

    if (showPasswordFields && passwordData.currentPassword !== "" && passwordData.newPassword !== "" && passwordData.confirmNewPassword !== "") {

      const requestPasswordData = {
        currentPassword: passwordData.currentPassword,
        password: passwordData.newPassword,
        confirmPassword: passwordData.confirmNewPassword,
      };

      await UserAPI.updateMyPassword(
        token,
        localStorage.getItem("groupId"),
        localStorage.getItem("companyId"),
        requestPasswordData
      )
        .then((response) => {
          setIsModified(false);
          openNotificationWithIcon(
            "success",
            "Successful",
            `${response.message}`,
            "bottomLeft"
          );
          setPasswordData({
            currentPassword: "",
            newPassword: "",
            confirmNewPassword: "",
          });
          setTimeout(() => {
            dispatch(logout());
            navigate("/login");
          }, 6000);

          clearPasswordData();
        })
        .catch((err) => {
          if (err.response) {
            setIsModified(true);
            openNotificationWithIcon(
              "error",
              "Password update failed",
              `${err.response.data.message}`,
              "bottomLeft"
            );
          } else {
            setIsModified(true);
            openNotificationWithIcon(
              "error",
              "Password update failed",
              `${err.message}`,
              "bottomLeft"
            );
          }
        });
    }
  };

  const uploadProfilePicture = async (file) => {
    let uploadProfilePictureMsg = "";
    if (file !== null) {
      const profilePicture = new FormData();
      profilePicture.append("profilePicture", file);

      await SettingAPI.uploadProfilePicture(
        token,
        localStorage.getItem("groupId"),
        localStorage.getItem("companyId"),
        payload._id,
        profilePicture
      )
        .then((response) => {
          refreshLayout();
          openNotificationWithIcon(
            "success",
            "Successful",
            `${response.message}`,
            "bottomLeft"
          );
        })
        .catch((err) => {
          if (err.response) {
            openNotificationWithIcon(
              "error",
              "Profile picture update failed",
              `${err.response.data.message}`,
              "bottomLeft"
            );
          } else {
            openNotificationWithIcon(
              "error",
              "Profile picture update failed",
              `${err.message}`,
              "bottomLeft"
            );
          }
        });
    } else {
      uploadProfilePictureMsg = "Profile picture update failed";
    }
    console.log("filelist length", fileList.length);
    return uploadProfilePictureMsg;
  };

  const deleteMyProfilePicture = async () => {
    let deleteProfilePictureMsg = "";
    const decodedTokenValue = decodeToken(token);
    await UserAPI.deleteMyProfilePicture(
      token,
      localStorage.getItem("groupId"),
      localStorage.getItem("companyId"),
      decodedTokenValue.userId
    )
      .then((response) => {
        refreshLayout();
        openNotificationWithIcon(
          "success",
          "Successful",
          `${response.message}`,
          "bottomLeft"
        );
      })
      .catch((err) => {
        if (err.response) {
          openNotificationWithIcon(
            "error",
            "Profile picture update failed",
            `${err.response.data.message}`,
            "bottomLeft"
          );
        } else {
          openNotificationWithIcon(
            "error",
            "Profile picture update failed",
            `${err.message}`,
            "bottomLeft"
          );
        }
        return deleteProfilePictureMsg;
      });
  };

  return (
    <>
      <Row>
        {contextHolder}
        <Col md={24}>
          <Breadcrumb style={{ margin: "16px 0" }}>
            <Breadcrumb.Item href="/dashboard">
              <HomeOutlined />
            </Breadcrumb.Item>
            <Breadcrumb.Item>User Profile</Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <div className="border-container">
        <Button
          type="primary"
          variant="dashed"
          className="card-button"
          size="large"
          icon={<HomeOutlined />}
          onClick={goHome}
          shape="circle"
        ></Button>
        <Card style={{ minHeight: "70vh" }}>
          {isLoad && (
            <Row>
              <Col md={8}></Col>
              <Col md={8}>
                <br />
                <Flex justify="center" align="middle">
                  <Upload
                    name="file"
                    maxCount={1}
                    listType="picture-circle"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                    beforeUpload={beforeUpload}
                    showUploadList={{showPreviewIcon: false,showRemoveIcon: true}}
                    onRemove={handleRemove}
                  >
                    {fileList.length === 0 && uploadButton}
                  </Upload>
                </Flex>

                <div style={{ marginTop: 20 }}>
                  <Form layout="vertical">
                    <Form.Item
                      label="First Name"
                      validateStatus={errors.userFirstName ? "error" : ""}
                      help={errors.userFirstName || ""}
                      required
                    >
                      <Input
                        size="large"
                        name="firstName"
                        value={payload["firstName"]}
                        onChange={(e) => {
                          setPayload((prev) => ({
                            ...prev,
                            firstName: e.target.value,
                          }));
                          const validateData = {
                            userFirstName: e.target.value,
                          };
                          //console.log("changed firstname",e.target.value)
                          if(loadingData["firstName"] !==e.target.value)
                          {
                            validateFormData(validateData);
                          }
                          else{
                            setIsModified(false);
                          }
                        }}
                        placeholder="First Name"
                      />
                    </Form.Item>

                    <Form.Item
                      label="Last Name"
                      validateStatus={errors.userLastName ? "error" : ""}
                      help={errors.userLastName || ""}
                      required
                    >
                      <Input
                        size="large"
                        name="lastName"
                        value={payload["lastName"]}
                        onChange={(e) => {
                          setPayload((prev) => ({
                            ...prev,
                            lastName: e.target.value,
                          }));
                          const validateData = { userLastName: e.target.value };

                          if(loadingData["lastName"] !== e.target.value)
                          {
                            validateFormData(validateData);
                          }
                          else{
                            setIsModified(false);
                          }
                        }}
                        placeholder="Last Name"
                      />
                    </Form.Item>

                    <Form.Item
                      label="Email Address"
                      validateStatus={errors.email ? "error" : ""}
                      help={errors.email || ""}
                      required
                    >
                      <Input
                        size="large"
                        name="email"
                        disabled
                        value={payload["email"]}
                        onChange={(e) => {
                          setPayload((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }));
                          const validateData = { email: e.target.value };
                          validateFormData(validateData);
                        }}
                        placeholder="Email Address"
                      />
                    </Form.Item>

                    <Form.Item label="User Type" required>
                      <Input
                        size="large"
                        name="userType"
                        disabled
                        value={payload["userType"]}
                        placeholder="User Type"
                      />
                    </Form.Item>

                    <Form.Item>
                      <Checkbox
                        onChange={(e) =>
                          setShowPasswordFields(e.target.checked)
                        }
                        size="large"
                        style={{ borderRadius: "3px" }}
                      >
                        Change Password
                      </Checkbox>
                    </Form.Item>

                    {showPasswordFields && (
                      <>
                        <Form.Item
                          label="Current Password"
                          validateStatus={errors.currentPassword ? "error" : ""}
                          help={errors.currentPassword || ""}
                          required
                        >
                          <Input.Password
                            size="large"
                            name="currentPassword"
                            value={passwordData.currentPassword}
                            ref={currentPasswordRef}
                            onChange={(e) => {
                              const updatedPasswordData = {
                                ...passwordData,
                                currentPassword: e.target.value,
                              };
                              setPasswordData(updatedPasswordData);
                              const validationResult =
                                validatePasswords(updatedPasswordData);
                              setErrors(validationResult.errors);
                            }}
                            placeholder="Current Password"
                          />
                        </Form.Item>

                        <Popover
                          content={renderPasswordRules()}
                          title="Password Requirements"
                          visible={popoverVisible}
                        >
                          <Form.Item
                            label="New Password"
                            validateStatus={errors.newPassword ? "error" : ""}
                            help={errors.newPassword || ""}
                            required
                          >
                            <Input.Password
                              size="large"
                              name="newPassword"
                              placeholder="New Password"
                              prefix={
                                <LockOutlined
                                  style={{ color: colorTextQuaternary }}
                                />
                              }
                              value={passwordData.newPassword}
                              ref={newPasswordRef}
                              onPaste={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                              onCopy={(e) => {
                                e.preventDefault();
                                return false;
                              }}
                              autoComplete="off"
                              onChange={(e) => {
                                setPasswordData({
                                  ...passwordData,
                                  newPassword: e.target.value,
                                });
                                const updatedPasswordData = {
                                  ...passwordData,
                                  newPassword: e.target.value,
                                };
                                const validationResult =
                                  validatePasswords(updatedPasswordData);
                                setErrors(validationResult.errors);
                              }}
                              onFocus={() => setPopoverVisible(true)}
                              onBlur={() => setPopoverVisible(false)}
                              const
                              validateData
                            />
                          </Form.Item>
                        </Popover>

                        <Form.Item
                          label="Confirm New Password"
                          validateStatus={
                            errors.confirmNewPassword ? "error" : ""
                          }
                          help={errors.confirmNewPassword || ""}
                          required
                        >
                          <Input.Password
                            size="large"
                            name="confirmNewPassword"
                            value={passwordData.confirmNewPassword}
                            ref={confirmNewPasswordRef}
                            onPaste={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            onCopy={(e) => {
                              e.preventDefault();
                              return false;
                            }}
                            autoComplete="off"
                            onChange={(e) => {
                              setPasswordData({
                                ...passwordData,
                                confirmNewPassword: e.target.value,
                              });
                              const updatedPasswordData = {
                                ...passwordData,
                                confirmNewPassword: e.target.value,
                              };
                              const validationResult =
                                validatePasswords(updatedPasswordData);
                              setErrors(validationResult.errors);
                            }}
                            placeholder="Confirm New Password"
                          />
                        </Form.Item>
                      </>
                    )}

                    <Form.Item>
                      <Popconfirm
                        title={`Do you want to update your profile details?`}
                        open={showPopconfirm}
                        onConfirm={() => onSubmitChange()}
                        onCancel={handleCancel}
                        okText="Yes"
                        cancelText="No"
                        cancelButtonProps={{ disabled: cancelButtonDisabled }}
                      >
                        <Button
                          disabled={!isModified}
                          // onClick={onSubmitChange}
                          onClick={handleCreateUpdateClick}
                          type="primary"
                          block
                          htmlType="submit"
                          style={{ marginTop: "15px" }}
                          size="large"
                        >
                          Update
                        </Button>
                      </Popconfirm>
                    </Form.Item>
                  </Form>
                </div>
              </Col>
            </Row>
          )}
        </Card>
      </div>
    </>
  );
};

export default ProfilePage;
